import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {
  MDBCard,
  MDBCardBody,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBRow,
} from "mdb-react-ui-kit";
import sparkasse_logo from "../assets/img/sparkasse_logo.png";
import un_logo from "../assets/img/un_logo.png";
import european_bank_logo from "../assets/img/european_bank_logo.png";
import osce_logo from "../assets/img/osce_logo.png";
import us_embassy_logo from "../assets/img/us_embassy_logo.png";
import undp_logo from "../assets/img/undp_logo.png";

export const Testimonials = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <MDBContainer className="py-5">
      <MDBRow className="d-flex justify-content-center">
        <MDBCol md="10" xl="8" className="text-center testimonials">
          <h2 className="mb-4 ">TESTIMONIALS</h2>
        </MDBCol>
      </MDBRow>
      <MDBRow className="text-center d-flex align-items-stretch">
        <Carousel responsive={responsive}>
          <div>
            <MDBCol
              md="12"
              className="px-2 mb-5 mb-md-0 d-flex align-items-stretch"
            >
              <MDBCard className="testimonial-card">
                <div className="card-up"></div>
                <div className="avatar mx-auto c">
                  <img src={osce_logo} className="rounded-circle img-fluid" />
                </div>
                <MDBCardBody>
                  <hr />
                  <p className="dark-grey-text mt-4">
                    <MDBIcon fas icon="quote-left" className="pe-2" />
                    The system is very user friendly and available in three
                    languages (Macedonian, Albanian and English). Since it is
                    intended for users that are not IT experts, special
                    attention was paid on simplicity and intuitiveness, which
                    the company especially managed to achieve. The architecture
                    of the solution is flexible enough and allows for easy
                    extensibility in the future. <hr></hr>{" "}
                    <span className="testimonial-signature">
                      <p>
                        <i> National Rule of Law Officer - Human Dimension</i>{" "}
                        <br></br>
                        <b>OSCE Mission in Skopje</b>
                      </p>
                    </span>
                  </p>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </div>
          <div>
            <MDBCol
              md="12"
              className="px-2 mb-5 mb-md-0 d-flex align-items-stretch"
            >
              <MDBCard className="testimonial-card">
                <div className="card-up"></div>
                <div className="avatar mx-auto bg-white">
                  <img
                    src={european_bank_logo}
                    className="rounded-circle img-fluid"
                  />
                </div>
                <MDBCardBody>
                  <hr />
                  <p className="dark-grey-text mt-4">
                    <MDBIcon fas icon="quote-left" className="pe-2" />
                    They offer top notch quality, products, services, and rates.
                    In total, 42 e-courses were developed for “Support to
                    improve Effectiveness of Inspections- Capacity Building
                    eLearning platform” project, while collaborating with 16
                    different inspectors who were writing the content. The
                    project has been carried out in an exceptionally
                    professional manner, planned and executed ahead of time, in
                    compliance with the contractual terms. <hr></hr>{" "}
                    <span className="testimonial-signature">
                      <p>
                        <i>
                          Principal Counsellor, Governance and Political Affairs
                        </i>
                        <br></br>
                        <b>European Bank for Reconstruction and Development</b>
                      </p>
                    </span>
                  </p>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </div>
          <div>
            <MDBCol
              md="12"
              className="px-2 mb-5 mb-md-0 d-flex align-items-stretch"
            >
              <MDBCard className="testimonial-card">
                <div className="card-up"></div>
                <div className="avatar mx-auto bg-white">
                  <img src={undp_logo} className="rounded-circle img-fluid" />
                </div>
                <MDBCardBody>
                  <hr />
                  <p className="dark-grey-text mt-4">
                    <MDBIcon fas icon="quote-left" className="pe-2" />
                    The websites are easy-to-navigate and multilingual (MKD, AL,
                    En). Each website represents the concrete protected area and
                    its natural values. The websites provide educational
                    information, information about the flora and fauna,
                    geomorphology, hydrology, specifics amenities, tourist
                    offerings as well as the potential nature related tours in
                    the region and download of available maps for the area for
                    hiking, biking etc.<hr></hr>{" "}
                    <span className="testimonial-signature">
                      <p>
                        <i>UNDP Project Manager</i>
                        <br></br>
                        <b>Energy, Environment and Disaster Management</b>
                      </p>
                    </span>
                  </p>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </div>
          <div>
            <MDBCol
              md="12"
              className="px-2 mb-5 mb-md-0 d-flex align-items-stretch"
            >
              <MDBCard className="testimonial-card">
                <div className="card-up"></div>
                <div className="avatar mx-auto bg-white">
                  <img
                    src={us_embassy_logo}
                    className="rounded-circle img-fluid"
                  />
                </div>
                <MDBCardBody>
                  <hr />
                  <p className="dark-grey-text mt-4">
                    <MDBIcon fas icon="quote-left" className="pe-2" />
                    U.S. Embassy Skopje has been using the services that vendor
                    provides. The services include development of new website
                    for North Macedonia Academy for Judges and Public
                    Prosecutors as well as e-learning platform i.e. learning
                    management system (LMS) for the same Academy. U.S. Embassy
                    Skopje has used these services during 2019-2021.<hr></hr>{" "}
                    <span className="testimonial-signature">
                      <p>
                        <i>Contracting Officer</i>
                        <br></br>
                        <b>U.S. Embassy Skopje</b>
                      </p>
                    </span>
                  </p>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </div>

          <div>
            <MDBCol
              md="12"
              className="px-2 mb-5 mb-md-0 d-flex align-items-stretch"
            >
              <MDBCard className="testimonial-card">
                <div className="card-up"></div>
                <div className="avatar mx-auto bg-white">
                  <img src={un_logo} className="rounded-circle img-fluid" />
                </div>
                <MDBCardBody>
                  <hr />
                  <p className="dark-grey-text mt-4">
                    <MDBIcon fas icon="quote-left" className="pe-2" />
                    Despite a very short deadline, they developed a
                    well-functioning, modern, fully responsive and
                    easy-to-navigate featured with Content Management System
                    that is easy to use, update and maintain. <hr></hr>{" "}
                    <span className="testimonial-signature">
                      <p>
                        <i>UN Communications Officer</i>
                        <br></br>
                        <b>United Nations</b>
                      </p>
                    </span>
                  </p>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </div>
          <div>
            <MDBCol
              md="12"
              className="px-2 mb-5 mb-md-0 d-flex align-items-stretch"
            >
              <MDBCard className="testimonial-card">
                <div className="card-up"></div>
                <div className="avatar mx-auto bg-white">
                  <img
                    src={sparkasse_logo}
                    className="rounded-circle img-fluid"
                  />
                </div>
                <MDBCardBody>
                  <hr />
                  <p className="dark-grey-text mt-4">
                    <MDBIcon fas icon="quote-left" className="pe-2" />
                    EPISTUM LMS has responded to our needs in order to
                    effectively manage and track learning activities of the
                    employees. It provides optimal learning engagement, better
                    knowledge retention and business performance. Furthermore,
                    has provided customer support which responded to our needs
                    at any given time. <hr></hr>{" "}
                    <span className="testimonial-signature">
                      <p>
                        <i>Human Resources Department</i>
                        <br></br>
                        <b>Sparkasse Bank Makedonija</b>
                      </p>
                    </span>
                  </p>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </div>
        </Carousel>
      </MDBRow>
    </MDBContainer>
  );
};
